/* The header is editorial content, not a checkout shipping rule. */
(function () {
  'use strict';
  var script = document.querySelector('[data-tnt-promo-config]');
  if (!script) return;
  var settings, selected;
  function province() {
    if (window.TntProvinceStock) return window.TntProvinceStock.selectedProvince();
    var requested = new URL(location.href).searchParams.get('province');
    if (requested) return requested;
    try {
      var cookie = document.cookie.match(/(?:^|;\s*)tnt_province=([^;]*)/);
      return cookie ? decodeURIComponent(cookie[1]) : localStorage.getItem('tnt_province');
    } catch (_) { return null; }
  }
  function valid(message) {
    if (!message || typeof message.text !== 'string' || !message.text.trim() ||
        message.text.length > 180 || typeof message.link !== 'string' ||
        /[\u0000-\u001f\u007f\\]/.test(message.link)) return false;
    try {
      var url = new URL(message.link, location.origin);
      return !url.username && !url.password &&
        (message.link.startsWith('/') && !message.link.startsWith('//')
          ? url.origin === location.origin
          : message.link.startsWith('https://') && url.protocol === 'https:');
    } catch (_) { return false; }
  }
  function apply() {
    var banner = document.getElementById('tnt-promo-banner');
    if (!banner) return;
    banner.hidden = !settings;
    if (!settings) return;
    var code = selected === undefined ? province() : selected;
    var message = !code || code === 'NL' ? settings.nl : settings.canada;
    var text = document.getElementById('tnt-promo-text') || banner;
    text.textContent = message.text;
    var href = new URL(message.link, location.origin);
    // The promoted shopping page should open in the selected destination too.
    if (code && href.origin === location.origin && /^\/(?:collections\/|search)/.test(href.pathname)) {
      href.searchParams.set('province', code);
    }
    banner.href = href.href;
    banner.dataset.tntPromoAudience = !code || code === 'NL' ? 'nl' : 'canada';
  }
  document.addEventListener('tnt:provinceChanged', function (event) {
    selected = event.detail.province;
    apply();
  });
  async function initialize() {
    if (!document.getElementById('tnt-promo-banner')) return;
    apply();
    var controller = new AbortController();
    var deadline = setTimeout(function () { controller.abort(); }, 8000);
    try {
      var url = new URL(script.dataset.tntPromoConfig, location.href);
      // Do not pin editorial content to an old asset version embedded in a
      // cached homepage. A new page visit gets the latest saved configuration.
      url.searchParams.delete('v');
      url.searchParams.set('tnt_refresh', String(Date.now()));
      var response = await fetch(url.href, { cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Header configuration unavailable');
      var value = await response.json();
      if (!valid(value.nl) || !valid(value.canada)) throw new Error('Invalid header configuration');
      settings = value; apply();
    } catch (error) {
      console.warn('[TNT header] Banner hidden because its saved configuration could not be loaded.');
    } finally { clearTimeout(deadline); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
